export default __webpack_public_path__ + "static/media/vendor_payment.04f1d12f.xlsx";